export function getFormatMaxDecimals(
  value: number,
  targetDecimals?: number | null,
): number {
  const decimals = targetDecimals ?? 3;
  if (Math.abs(Math.round(value)) >= 1 || value === 0) return decimals;
  const valueString = value.toFixed(20);
  const [, decimalPart = ""] = valueString.split(".");
  if (!decimalPart) return 0;
  const leadingZeros = decimalPart.match(/^0*/)?.[0].length ?? 0;
  return leadingZeros + decimals;
}
